/**
 * Deltek/Ajera reference data.
 *
 * Two rules from CLAUDE.md drive everything in this file:
 *   1. Deltek/Ajera is READ-ONLY. Nothing here describes a write.
 *   2. We persist the Ajera SURROGATE KEY and nothing else. Display names and
 *      business identifiers (employee ID, job number) change over time; the
 *      surrogate key does not. Names are resolved at read time.
 */
/** Wrap a raw surrogate key coming from the CSV seed or the database. */
export function ajeraKey(value) {
    const trimmed = value.trim();
    if (trimmed === "") {
        throw new Error("Ajera surrogate key cannot be empty");
    }
    return trimmed;
}
/** Azure's words for "not finished". Both appear; neither is evidence. */
const IN_FLIGHT = ["running", "processing"];
export function syncHealth(executions, lastRefreshAt) {
    const inFlight = executions.find((e) => IN_FLIGHT.includes(e.status.toLowerCase()));
    if (inFlight)
        return { kind: "running", startedAt: inFlight.startedAt };
    // Only a FINISHED run is evidence of anything.
    const finished = executions.find((e) => !IN_FLIGHT.includes(e.status.toLowerCase()));
    if (!finished?.startedAt)
        return { kind: "ok" };
    // Nothing has ever been recorded, and a run has finished: that run was
    // silent. Before the first sync there are no executions either, so this
    // cannot fire on a fresh environment.
    if (lastRefreshAt === null)
        return { kind: "silent", startedAt: finished.startedAt };
    // Compare against the run's START, never its end: the job writes its rows a
    // few seconds BEFORE the container exits, so comparing end times would flag
    // every healthy run all over again.
    return new Date(finished.startedAt) > new Date(lastRefreshAt)
        ? { kind: "silent", startedAt: finished.startedAt }
        : { kind: "ok" };
}
//# sourceMappingURL=deltek.js.map